/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { Effect, WorkOrder } from "../../utils/Interfaces";
import { useWindowDimensions } from "../../utils/Hooks";
import Button from "@mui/material/Button";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import NoteAddIcon from "@mui/icons-material/NoteAddOutlined";
import React from "react";
import DataTable from "../../components/table/DataTable";
import { TabPanel } from "../../components/tabs/TabPanel";
import { GridColDef } from "@mui/x-data-grid";

export interface TabDataPageProps {
    index: number;
    columns: GridColDef<any, any, any>[];
    data: WorkOrder[];
    handleImportModalOpen: Effect;
    onClickAddNew: Effect;
    indexValue: number;
    label: string;
}

export const TabDataPage = (props: TabDataPageProps) => {
    const { index, columns, data, handleImportModalOpen, onClickAddNew, indexValue, label } = props;

    const { height } = useWindowDimensions();

    return (
        <TabPanel index={index} selected={index === indexValue}>
            <DataTable
                tableName={`WORK_ORDER_LIST_${label}`}
                height={height - 233}
                columns={columns}
                data={[...data]}
                allowRowSelected={false}
            >
                <Button onClick={handleImportModalOpen}>
                    <UploadFileIcon fontSize="small" />
                    &nbsp; Import From Walmart
                </Button>
                <Button onClick={onClickAddNew}>
                    <NoteAddIcon fontSize="small" />
                    &nbsp; Add new work order
                </Button>
            </DataTable>
        </TabPanel>
    );
};
